import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Props {
  projectId: string
}

interface Args {
  taskId: string
}

export function useDeleteTaskMutation(props: Props) {
  const {
    projectId
  } = props

  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["task-delete"],
    async (args: Args) => {
      const {
        taskId
      } = args
      const response = await apiClient.deleteTask(projectId, taskId)

      if (!response.ok) {
        throw response.errors
      }

      return response
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["project-task", projectId, variables.taskId])
        queryClient.invalidateQueries(["project-sections", projectId], { exact: false})
      },
    }
  )

  return mutation
}
